module.exports = __webpack_public_path__ + "static/media/itauLogo.2d1fc3ac.png";